import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';


const routes: Routes = [
  {
    path: 'keylesson',
    loadChildren: () => import('./keylesson/keylesson.module').then(m => m.KeylessonModule)
  },
  {
    path: 'advancedlesson',
    loadChildren: () => import('./advancedlesson/advancedlesson.module').then(m => m.AdvancedlessonModule)
  },
  {
    path: 'advancedresults',
    loadChildren: () => import('./advancedresults/advancedresults.module').then(m => m.AdvancedresultsModule)
  },
  {
    path: 'keyresults',
    loadChildren: () => import('./keyresults/keyresults.module').then(m => m.KeyresultsModule)
  },
  {
    path: 'exam',
    loadChildren: () => import('./exam/exam.module').then(m => m.ExamModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  { 
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: '404',
    component: PageNotFoundComponent
  },
  {
    path: '**',
    redirectTo: '/404',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
